import { observer } from 'mobx-react';
import React from 'react';
import { Instance } from 'mobx-state-tree';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';

interface PharmacyDetailProps {
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
}

@observer
class PharmacyDetail extends React.Component<PharmacyDetailProps> {
  render() {
    const { pharmacyDetails } = this.props;
    return (
      <div>
        <div>
          <p />
          <div style={{ fontWeight: 'bold' }}>
            {pharmacyDetails ? pharmacyDetails!.apbNumber + ' - ' + pharmacyDetails!.name : ''}
          </div>
          {/* <div>{pharmacyDetails ? 'nom du pharmacien' : ''}</div> */}
          <div>
            {pharmacyDetails ? pharmacyDetails!.address : ''},&nbsp;{pharmacyDetails ? pharmacyDetails!.zipCode : ''}
            &nbsp;{pharmacyDetails ? pharmacyDetails!.city : ''}
          </div>
          <div>Tél.:&nbsp;{pharmacyDetails ? pharmacyDetails!.phone : ''}</div>
        </div>
      </div>
    );
  }
}

export default PharmacyDetail;
